let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4eYRm")).then(() => parcelRequire('8bqsn'));